module.exports = __webpack_public_path__ + "assets/img/8.7d2a4af3.png";